export default __webpack_public_path__ + "static/media/05.7ee56802.jpg";